import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import Button from "./Button";

const SignInBanner = () => {
  const { user, loading } = useUser();

  if (loading || user) {
    return null;
  }

  return (
    <div className="container mt-8 mx-auto flex justify-center print:hidden">
      <div className="flex flex-col items-center gap-3 px-4 py-4 border-4 border-secondary border-dashed rounded-xl">
        <p className="font-sans font-semibold sm:text-lg">
          Create an account to add your own recipes and save your favorites for later!
        </p>
        <Button type="primary" as={Link} to="signIn">Join Now</Button>
      </div>
    </div>
  );
};

export default SignInBanner;
